/*
 * @Author: your name
 * @Date: 2021-02-21 21:57:22
 * @LastEditTime: 2022-03-09 00:13:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /red_packet_admin/src/api/request.js
 */
import Vue from "vue";
import axios from "axios";
import { Toast } from "vant";

const service = axios.create({
  timeout: 30000,
  baseURL: "/touch",
});

service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;

    if (!response.config.noIntercept && res.code != 200) {
      if (res.code != 200) {
        Toast.fail(res.errMsg || "Error");
      }

      if (res.code === 4000) {
        Vue.toLogin();
      }

      return Promise.reject(new Error(res.errMsg || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    console.log("err" + error);

    // 失败提示
    Toast.fail(error.message);
    return Promise.reject(error);
  }
);

export default service;
